import React from "react";
import CTASection from "../components/CTASection";
import PageHero from "../components/PageHero";
import { SITE_ASSETS } from "../mock";
import { useSettings } from "../context/SettingsContext";
import { ArrowUpRight, MapPin } from "lucide-react";

export default function ProjectsPage() {
  const { projects } = useSettings();
  return (
    <>
      <PageHero
        eyebrow="Tamra Address Collection"
        title="Iconic addresses."
        italicWord="addresses"
        description="A growing portfolio of premium high-rises and mixed-use destinations across Hyderabad — each conceived as a long-term landmark."
        image={SITE_ASSETS.hero.aerial}
      />

      <section className="pb-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 space-y-24">
          {projects.map((p, i) => (
            <div key={p.id} className={`grid lg:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <div className="lg:col-span-7 aspect-[16/10] overflow-hidden">
                <img src={p.cover} alt={p.name} className="w-full h-full object-cover img-hover" />
              </div>
              <div className="lg:col-span-5">
                <div className="text-[11px] tracking-[0.5em] uppercase text-[#B8893C] mb-3">{p.status}</div>
                <h2 className="font-display text-4xl md:text-5xl tracking-[0.05em] text-[#1F1B17]">{p.name}</h2>
                <div className="flex items-center gap-2 text-[#3a322a] mt-3 text-sm">
                  <MapPin size={14} className="text-[#B8893C]" /> {p.location} · {p.type}
                </div>
                <p className="mt-6 text-[#3a322a] leading-relaxed">{p.description}</p>
                <div className="flex flex-wrap gap-2 mt-6">
                  {p.highlights.map((h) => (
                    <span key={h} className="px-3 py-1.5 text-[11px] tracking-[0.2em] uppercase border border-[#B8893C]/50 text-[#5C2018]">{h}</span>
                  ))}
                </div>
                <a href="/contact" className="btn-primary mt-10">Enquire <ArrowUpRight size={14} /></a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
}
